import e from "moment";
function i(t) {
  return Math.ceil((t ?? e()).minutes() / 10) * 10;
}
export {
  i as default
};
